import React from 'react';
import PropTypes from 'prop-types';
import { ItemContainer, Label, ContentWrapper } from './styled';

const Item = ({ name, description, background }) => {
  const itemVariants = {
    initial: {
      y: 20,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  return (
    <ItemContainer variants={itemVariants}>
      <Label background={background} />

      <ContentWrapper>
        <h5>{name}</h5>
        <p>{description}</p>
      </ContentWrapper>
    </ItemContainer>
  );
};

export default Item;

Item.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  background: PropTypes.string
};
